import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Loading } from "@/components/atoms";
import { PageHeader, ProfileDetails, ProfileHeader } from "@/components/organisms";
import { useGetProfileQuery } from "@/redux/apis/profile/profileApi";
import { ProfileEdit } from "./ProfileEdit";
import { ProfilePaymentMethodSetup } from "./ProfilePaymentMethodSetup";
import { ProfileSignUpSuccess } from "./ProfileSignUpSuccess";

export const Profile = () => {
  const [params] = useSearchParams();
  const { isLoading, refetch } = useGetProfileQuery();

  useEffect(() => {
    if (params.get("updated")) refetch();
  }, [refetch, params]);

  if (isLoading) return <Loading />;

  return (
    <>
      <PageHeader skipCrumbs={1} title="Profile" />
      <div className="mb-4 mt-2 overflow-hidden rounded-lg shadow-lg">
        <ProfileHeader />
        <ProfileDetails />
      </div>
    </>
  );
};

Profile.Edit = ProfileEdit;
Profile.SignUpSuccess = ProfileSignUpSuccess;
Profile.PaymentMethodSetup = ProfilePaymentMethodSetup;
